
import { create, day as day_1, month as month_1, year as year_1 } from "../fable_modules/fable-library-js.5.3.0/DateOnly.js";
import { split, printf, toText } from "../fable_modules/fable-library-js.5.3.0/String.js";
import { string, succeed, fail, andThen } from "../fable_modules/Thoth.Json.10.5.1/Decode.fs.js";
import { defaultOf, uncurry3 } from "../fable_modules/fable-library-js.5.3.0/Util.js";
import { item, equalsWith } from "../fable_modules/fable-library-js.5.3.0/Array.js";
import { tryParse } from "../fable_modules/fable-library-js.5.3.0/Int32.js";
import { FSharpRef } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { newGuid } from "../fable_modules/fable-library-js.5.3.0/Guid.js";
import { add } from "../fable_modules/fable-library-js.5.3.0/Map.js";
import { decimal } from "../fable_modules/Thoth.Json.10.5.1/Encode.fs.js";
import { decimal as decimal_1 } from "../fable_modules/Thoth.Json.10.5.1/Decode.fs.js";
import { empty } from "../fable_modules/Thoth.Json.10.5.1/Extra.fs.js";
import { ExtraCoders } from "../fable_modules/Thoth.Json.10.5.1/Types.fs.js";

function dateOnlyEncoder(date) {
    let arg, arg_1, arg_2;
    return (arg = (year_1(date) | 0), (arg_1 = (month_1(date) | 0), (arg_2 = (day_1(date) | 0), toText(printf("%04d-%02d-%02d"))(arg)(arg_1)(arg_2))));
}

const dateOnlyDecoder = (path_4) => ((value_1) => andThen(uncurry3((s) => {
    const matchValue = split(s, ["-"], undefined, 0);
    if (!equalsWith((x, y) => (x === y), matchValue, defaultOf()) && (matchValue.length === 3)) {
        const y_1 = item(0, matchValue);
        const m = item(1, matchValue);
        const d = item(2, matchValue);
        let matchValue_1;
        let outArg = 0;
        matchValue_1 = [tryParse(y_1, 511, false, 32, new FSharpRef(() => (outArg | 0), (v) => {
            outArg = (v | 0);
        })), outArg];
        let matchValue_2;
        let outArg_1 = 0;
        matchValue_2 = [tryParse(m, 511, false, 32, new FSharpRef(() => (outArg_1 | 0), (v_1) => {
            outArg_1 = (v_1 | 0);
        })), outArg_1];
        let matchValue_3;
        let outArg_2 = 0;
        matchValue_3 = [tryParse(d, 511, false, 32, new FSharpRef(() => (outArg_2 | 0), (v_2) => {
            outArg_2 = (v_2 | 0);
        })), outArg_2];
        let matchResult;
        if (matchValue_1[0]) {
            if (matchValue_2[0]) {
                if (matchValue_3[0]) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                try {
                    const output = create(matchValue_1[1], matchValue_2[1], matchValue_3[1]);
                    return (arg10$0040) => ((arg20$0040) => succeed(output, arg10$0040, arg20$0040));
                }
                catch (matchValue_5) {
                    const msg = toText(printf("Failed to parse DateOnly from \'%s\'"))(s);
                    return (path_1) => ((arg20$0040_1) => fail(msg, path_1, arg20$0040_1));
                }
            default: {
                const msg_1 = toText(printf("Failed to parse DateOnly from \'%s\'"))(s);
                return (path_2) => ((arg20$0040_2) => fail(msg_1, path_2, arg20$0040_2));
            }
        }
    }
    else {
        const msg_2 = toText(printf("Failed to parse DateOnly from \'%s\'"))(s);
        return (path_3) => ((arg20$0040_3) => fail(msg_2, path_3, arg20$0040_3));
    }
}), string, path_4, value_1));

export const extra = (() => {
    let copyOfStruct, copyOfStruct_1;
    const extra_4 = new ExtraCoders((copyOfStruct = newGuid(), copyOfStruct), add("System.Decimal", [decimal, (path) => ((value_1) => decimal_1(path, value_1))], empty.Coders));
    return new ExtraCoders((copyOfStruct_1 = newGuid(), copyOfStruct_1), add("System.DateOnly", [dateOnlyEncoder, dateOnlyDecoder], extra_4.Coders));
})();

//# sourceMappingURL=SsrCoders.js.map
